module.exports = __webpack_public_path__ + "img/c3.53a05728.jpg";